import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";

/**
 *
 * @param {any[]} serviceDetailedBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  serviceDetailedBalance,
  selectedStore,
  startDate,
  endDate
) => {
  const excelData = [];

  let totalIncome = 0;

  for (let item = 0; item < serviceDetailedBalance.length; item++) {
    const balance = serviceDetailedBalance[item];
    const serviceConceptArray = [];
    const employeeListArray = [];
    const employeeCountArray = [];
    let serviceTotalPrice = 0;
    let serviceConcept = "";
    let employeeList = "";
    const employeeIdArray = [];

    balance.Sell_details.forEach((element) => {
      serviceConceptArray.push(element.quantity + " " + element.Service.name);
    });
    serviceConcept = serviceConceptArray.join("/");

    let index = 0;
    balance.Sell_details.forEach((element) => {
      element.Employees.forEach((employee) => {
        if (employeeIdArray.includes(employee.id)) {
          index = employeeIdArray.findIndex((id) => id === employee.id);
          employeeCountArray[index] += 1;
        } else {
          employeeIdArray.push(employee.id);
          employeeCountArray.push(1);
          employeeListArray.push(employee.name + " " + employee.lastname);
        }
      });
    });

    for (let index = 0; index < employeeListArray.length; index++) {
      employeeListArray[index] =
        employeeCountArray[index] + " " + employeeListArray[index];
    }
    employeeList = employeeListArray.join("/");

    balance.Sell_details.forEach((sell_detail) => {
      serviceTotalPrice += sell_detail.total_net;
    });

    totalIncome += serviceTotalPrice;

    excelData.push({
      order: item + 1,
      customer: `${balance.Customer.name} ${balance.Customer.lastname}`,
      employee: employeeList,
      services: serviceConcept,
      paymentType: balance.Sell_payment_type.name,
      totalPrice: serviceTotalPrice,
    });
  }
  excelData.push({
    order: "",
    customer: "TOTAL",
    employee: "",
    services: "",
    paymentType: "",
    totalPrice: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR SERVICIOS DETALLADO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "employee",
            outValue: "EMPLEADOS",
          },
          {
            inValue: "services",
            outValue: "CONCEPTO",
          },
          {
            inValue: "paymentType",
            outValue: "FORMA DE PAGO",
          },
          {
            inValue: "totalPrice",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-general-por-servicio_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-por-servicio_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};

/**
 *
 * @param {any[]} serviceBalance
 * @returns {Workbook}
 */
export const exportExcelGeneral = async (
  serviceBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalQuantity = 0;
  let totalIncome = 0;

  const excelData = [];

  for (let item = 0; item < serviceBalance.length; item++) {
    const balance = serviceBalance[item];

    excelData.push({
      order: item + 1,
      name: balance.name,
      quantity: balance.quantity,
      total: balance.total,
    });

    totalQuantity += balance.quantity;
    totalIncome += balance.total;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR SERVICIOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "SERVICIO",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileNameGeneral(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileNameGeneral = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-servicio_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-servicio_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ServiceBalance/excel.js